var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-date-menu-root"},[_c('tooltip',{attrs:{"placement":"right","content":_vm.description}},[_c('button',{staticClass:"fixed-date-menu-button-icon",on:{"click":_vm.overwrite}},[_vm._v(_vm._s(_vm.phrase))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }